<template>
  <div class="menu-full">
    <v-app-bar
      id="header"
      app
      color="primary"
      dense
      :class="[{ '' /**'desktop-mode-padding' */: $vuetify.breakpoint.mdAndUp }, 'header', 'primaryText--text']"
    >
      <v-row>
        <v-col :cols="$vuetify.breakpoint.mdAndUp ? '3' : '2'" class="d-flex">
          <v-app-bar-nav-icon v-if="showNavBack" @click="pageBack">
            <v-icon v-if="$appMode == 1 && mainMenuCatSelected == null">mdi-storefront-outline</v-icon>
            <v-icon v-else>mdi-arrow-left</v-icon>
          </v-app-bar-nav-icon>

          <v-app-bar-nav-icon v-if="$appMode == 0" @click="onClickMenu"></v-app-bar-nav-icon>
        </v-col>

        <v-col :cols="$vuetify.breakpoint.mdAndUp ? '6' : '8'" class="d-flex justify-center">
          <div>
            <v-toolbar-title
              class="header-title1"
              v-if="$store.state.store != null && $store.state.store.info != null"
              >{{ $store.getters.storeName }}</v-toolbar-title
            >
            <v-toolbar-title class="header-title2"
              >{{ $t($store.getters.orderFrom)
              }}<span v-if="mainMenu.length > 0" class="header-title2-feature">{{
                headerCategoryTitle
              }}</span></v-toolbar-title
            >
          </div>
        </v-col>

        <v-col :cols="$vuetify.breakpoint.mdAndUp ? '3' : '2'" align-self="end" style="text-align: right">
          <v-badge
            v-show="!$store.getters.storeMenuMode"
            :value="$store.state.order.qtyTotal"
            :content="$store.state.order.qtyTotal"
            color="accent"
            class="accentText--text"
            overlap
            offset-x="20"
            offset-y="20"
          >
            <v-app-bar-nav-icon @click="checkOutClicked">
              <v-icon>mdi-cart-outline</v-icon>
            </v-app-bar-nav-icon>
          </v-badge>
        </v-col>
      </v-row>
    </v-app-bar>

    <v-container v-if="$store.state.store != null" class="mt-n3 x-no-max-width">
      <v-row v-if="mainMenuCatSelected == null" id="row-image">
        <img
          :src="$store.state.store.info.coverUri"
          id="store-cover"
          class="store-cover"
          v-if="$store.state.store.info.coverUri != null && $store.state.store.info.coverUri != ''"
        />
        <img
          :src="$store.state.store.info.logoUri"
          id="store-logo"
          class="store-logo"
          v-else-if="$store.state.store.info.logoUri != null && $store.state.store.info.logoUri != ''"
        />
      </v-row>

      <v-row
        class="store-message"
        v-if="
          storeMessage != '' &&
            $t(storeMessage) != storeMessage &&
            $t(storeMessage) != '' &&
            mainMenuCatSelected == null
        "
      >
        <v-col v-html="$t(storeMessage)">
          <!-- {{ $t(storeMessage) }} -->
        </v-col>
      </v-row>

      <div v-if="!$store.getters.acceptOrder && !$store.getters.storeMenuMode" class="not-accept-order">
        <v-chip color="accent" text-color="accentText">
          {{ $t("not_acception_order") }}
        </v-chip>
      </div>

      <ul
        id="cat-list"
        :class="['cat-list', ua_isMobile() ? 'cat-list-mobile' : 'cat-list-desktop']"
        v-if="orderMenuButtonsOnTopBar || categoriesOnTopBar"
      >
        <div v-if="orderMenuButtonsOnTopBar" style="padding: 10px 0px;">
          <v-btn-toggle v-model="$store.state.orderMenu" mandatory color="accent">
            <v-btn small>
              {{ $t("MENU.menu") }}
            </v-btn>
            <v-btn small>
              {{ $t("redeem") }}
            </v-btn>
          </v-btn-toggle>
        </div>

        <li v-for="cat in menu" :key="cat.ID">
          <v-chip
            v-if="categoriesOnTopBar"
            :key="cat.ID"
            @click="catClicked(cat)"
            :color="cat.ID == -2 ? 'accent' : cat.ID == -1 ? 'info' : ''"
            :text-color="cat.ID == -2 ? 'accentText' : cat.ID == -1 ? 'infoText' : ''"
          >
            <div v-if="cat.ID == -2">
              {{ $t("redeem") }}
              <v-icon small style="margin:0px 0px 2px 4px">mdi-gift-outline</v-icon>
            </div>
            <div v-else-if="cat.ID == -1">
              {{ $t("favorite") }}
              <v-icon small style="margin:0px 0px 2px 4px">
                mdi-heart-outline
              </v-icon>
            </div>
            <div v-else>
              {{ $store.getters.categoryDescr(cat) }}
            </div>
          </v-chip>
        </li>
      </ul>

      <PromoList
        v-if="
          $appMode == 0 &&
            $store.state.orderMenu == 0 &&
            $store.state.order.tableID == 0 &&
            !$store.getters.storeMenuMode &&
            mainMenuCatSelected == null
        "
      ></PromoList>

      <v-row v-if="mainMenu.length > 0 && mainMenuCatSelected == null" class="menu-row">
        <v-col class="menu-col" cols="12" sm="6" md="6" lg="4" x-xl="3" v-for="cat in mainMenu" :key="cat.ID">
          <MenuCategoryEle :cat="cat" @categoryClicked="mainMenuCatClicked"></MenuCategoryEle>
        </v-col>
      </v-row>

      <div v-show="mainMenu.length == 0 || mainMenuCatSelected != null" class="menu-container">
        <div
          v-show="$store.getters.categoryPosition == 'left'"
          :class="[/*{ 'mb-16': ua_isMobile() },*/ 'mb-16', 'menu-side']"
        >
          <v-list id="menu-side-list">
            <v-list-item v-for="cat in menu" :key="cat.ID" @click="catClicked(cat)">
              <div v-if="cat.ID == -2 && $store.state.pointRedeemEnabled" class="redeem-item">
                {{ $t("redeem") }}
              </div>
              <div v-else-if="cat.ID == -1" class="favorite-item">
                {{ $t("favorite") }}
              </div>
              <div v-else>
                <div v-if="$store.state.descrIndex == 0">
                  {{ cat.descr }}
                </div>
                <div v-if="$store.state.descrIndex == 1">
                  {{ cat.descr1 }}
                </div>
                <div v-if="$store.state.descrIndex == 2">
                  {{ cat.descr2 }}
                </div>
              </div>
            </v-list-item>
          </v-list>
        </div>

        <div :class="[/*{ 'mb-16': ua_isMobile() },*/ 'mb-16', 'menu-body']">
          <div v-for="cat in menu" :key="cat.ID">
            <div v-show="$store.getters.categoryPosition == 'top' || cat.ID == catID">
              <v-row
                :class="$store.getters.categoryPosition == 'top' ? 'menu-cat-header-top' : 'menu-cat-header-side'"
                :id="'c:' + cat.ID"
                v-if="menu != null && menu.length > 1"
              >
                <v-col v-if="cat.ID == -2" class="cat-redeem">
                  {{ $t("redeem") }}
                </v-col>

                <v-col v-if="cat.ID == -1" class="cat-favorite">
                  {{ $t("favorite") }}
                </v-col>

                <v-col v-if="cat.ID > 0" class="cat-normal">
                  <div v-if="$store.state.descrIndex == 0">
                    {{ cat.descr }}
                  </div>
                  <div v-if="$store.state.descrIndex == 1">
                    {{ cat.descr1 }}
                  </div>
                  <div v-if="$store.state.descrIndex == 2">
                    {{ cat.descr2 }}
                  </div>
                </v-col>
              </v-row>

              <v-row class="menu-cat-header-hidden" :id="cat.ID"></v-row>

              <v-row
                v-if="$store.state.descrIndex == 0 && cat.detail !== undefined && cat.detail != ''"
                :class="$store.getters.categoryPosition == 'top' ? 'menu-cat-detail-top' : 'menu-cat-detail-side'"
              >
                <span>{{ cat.detail }}</span>
              </v-row>
              <v-row
                v-if="$store.state.descrIndex == 1 && cat.detail1 !== undefined && cat.detail1 != ''"
                :class="$store.getters.categoryPosition == 'top' ? 'menu-cat-detail-top' : 'menu-cat-detail-side'"
              >
                <span>{{ cat.detail1 }}</span>
              </v-row>
              <v-row
                v-if="$store.state.descrIndex == 2 && cat.detail2 !== undefined && cat.detail2 != ''"
                :class="$store.getters.categoryPosition == 'top' ? 'menu-cat-detail-top' : 'menu-cat-detail-side'"
              >
                <span>{{ cat.detail2 }}</span>
              </v-row>

              <v-row :class="[{ 'ml-n1': $store.getters.categoryPosition == 'left' }, 'menu-row']" :id="'c:' + cat.ID">
                <v-col
                  :class="[
                    'menu-col',
                    {
                      'pl-1': $vuetify.breakpoint.xsOnly && $store.getters.categoryPosition == 'left',
                    },
                  ]"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="4"
                  x-xl="3"
                  v-for="item in filteredCatItems(cat)"
                  :key="item.ID"
                >
                  <MenuItemEle :item="item" @itemClicked="itemClicked"></MenuItemEle>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </div>
    </v-container>

    <!--     <v-fab-transition v-show="!$vuetify.breakpoint.mdAndUp">
      <v-btn color="primary" class="primaryText--text" fixed bottom right fab @click="searchItem">
        <v-icon>mdi-magnify</v-icon>
      </v-btn>
    </v-fab-transition> -->

    <BottomToolbar
      :mainMenuCatSelected="mainMenuCatSelected"
      @mainMenuCatClicked="mainMenuCatClicked"
      @orderTypeSwitched="orderTypeSwitched"
    ></BottomToolbar>
    <LoginSelector
      ref="loginSelector"
      :show="showLoginSelector"
      @cancel="loginCancel()"
      @completed="loginCompleted()"
    ></LoginSelector>

    <v-overlay :value="refreshing">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <AddShortcutToHomeScreen v-if="$store.state.rootName == 'MenuFull'"></AddShortcutToHomeScreen>
  </div>
</template>

<script>
import AddShortcutToHomeScreen from "@/components/AddShortcutToHomeScreen.vue";
import BottomToolbar from "@/components/BottomToolbar.vue";
import LoginSelector from "@/components/LoginSelector.vue";
import MenuCategoryEle from "@/components/MenuCategoryEle.vue";
import MenuItemEle from "@/components/MenuItemEle.vue";
import PromoList from "@/components/PromoList.vue";

export default {
  beforeRouteLeave(to, from, next) {
    let catListEle = document.getElementById("cat-list");
    if (catListEle != null) {
      this.catListScrollLeft = catListEle.scrollLeft;
    }
    let promoListEle = document.getElementById("promo-list");
    if (promoListEle != null) {
      this.promoListScrollLeft = promoListEle.scrollLeft;
    }
    next();
  },

  components: {
    AddShortcutToHomeScreen,
    BottomToolbar,
    LoginSelector,
    MenuCategoryEle,
    MenuItemEle,
    PromoList,
  },

  data() {
    return {
      refreshing: false,
      prevSessionKey: "",
      catID: 0,
      mainMenuCatSelected: null,

      showLoginSelector: false,

      headerHeight: 0,
      catListScrollLeft: 0,
      promoListScrollLeft: 0,
    };
  },

  created() {
    window.addEventListener("scroll", this.onScroll);
  },

  destroyed() {
    window.removeEventListener("scroll", this.onScroll);
  },

  mounted() {
    console.log("menu-full mounted");

    let eleHeader = document.getElementById("header");
    if (eleHeader) {
      this.headerHeight = eleHeader.offsetHeight;
    }
  },

  activated() {
    console.log("menu-full activated");

    this.resizeLeftMenu();
    if (
      (this.$appMode == 0 &&
        (this.$store.state.routeFrom.name == null || this.$store.state.routeFrom.name == "StoreHome")) ||
      (this.$appMode == 1 &&
        (this.$store.state.routeFrom.name == "Stores" ||
          this.$store.state.routeFrom.name == "Offer")) /* ||
          this.$store.state.routeFrom.name == "Checkout"*/
    ) {
      this.mainMenuCatSelected = null;

      if (
        this.$store.state.order.orderType == this.$store.state.OT_DINEIN &&
        this.$store.getters.storeCovidContactFormUrl != ""
      ) {
        let submittedTime = this.getCovidFormSubmitTime();
        let now = new Date();
        if (submittedTime == null || now.getTime() - submittedTime.getTime() > 86400000) {
          this.$root
            .customFormDialog("COVID-19 Contact Tracing Form", this.$store.getters.storeCovidContactFormUrl, true)
            .then(submit => {
              if (submit) {
                console.log("form submitted");
                this.setCovidFormSubmitTime();
              }
            });
        }
      }

      this.refreshing = true;
      this.rest_canAcceptOrder(this.$store.state.order.orderType)
        .then(resp => {
          this.$store.state.storeOrderHours = resp;

          if (this.$appMode == 1) {
            let item = this.$route.params.item;
            if (item != null) {
              if (this.$store.getters.acceptOrder) {
                if (item.bItems != null && item.bItems.length > 0) {
                  this.navName("OrderBundle", this.$route.params);
                } else {
                  let oi = this.itemToOrderItem(item);
                  this.addOrderItem(oi);
                }
              } else {
                this.$root.messageDialog(this.$t("not_acception_order"), "", this.$t("not_acception_order_message"));
              }
            }
          }
        })
        .finally(() => {
          this.refreshing = false;
        });

      this.catListScrollLeft = 0;
      this.promoListScrollLeft = 0;
      this.startMenu();
    }

    let msec = this.$vuetify.breakpoint.mdAndUp ? 200 : 0;
    setTimeout(() => {
      let catListEle = document.getElementById("cat-list");
      if (catListEle != null) {
        catListEle.scrollLeft = this.catListScrollLeft;
      }

      let promoListEle = document.getElementById("promo-list");
      if (promoListEle != null) {
        promoListEle.scrollLeft = this.promoListScrollLeft;
      }
    }, msec);

    this.$store.state.cartKey++;
  },

  computed: {
    showNavBack() {
      return this.$store.state.rootName != "MenuFull";
    },

    headerCategoryTitle() {
      let title = this.$t("category");
      if (this.mainMenuCatSelected != null) {
        if (this.mainMenuCatSelected.ID == -1) {
          title = this.$t("redeem");
        } else title = this.$store.getters.categoryDescr(this.mainMenuCatSelected);
      }

      return title;
    },

    orderMenuButtonsOnTopBar() {
      return (
        this.$store.state.pointEnabled &&
        this.$store.state.redeemMenu.length > 0 &&
        (!this.$store.getters.mainMenuEnabled || this.mainMenuCatSelected == null)
      );
    },

    categoriesOnTopBar() {
      return (
        this.$store.getters.categoryPosition == "top" &&
        (!this.$store.getters.mainMenuEnabled || this.mainMenuCatSelected != null)
      );
    },

    storeMessage() {
      if (this.$store.state.order.orderType == this.$store.state.OT_DINEIN) return "dinein-message";
      else if (this.$store.state.order.orderType == this.$store.state.OT_TAKEOUT) return "takeout-message";
      else if (this.$store.state.order.orderType == this.$store.state.OT_DELIVERY) return "delivery-message";
      else return "";
    },

    mainMenu() {
      let n_mainMenu = [];
      if (this.$store.getters.mainMenuEnabled) {
        if (this.$store.state.orderMenu == 1) {
          n_mainMenu = this.$store.state.redeemMenu;
        } else {
          n_mainMenu = this.$store.state.menu;
        }
        n_mainMenu = n_mainMenu.filter(
          cat => cat.pID == 0 && (cat.menuTypes == null || cat.menuTypes.includes(this.$store.state.order.orderType))
        );
      }

      return n_mainMenu;
    },

    menu() {
      let n_menu = [];
      if (this.$store.state.orderMenu == 1) {
        n_menu = this.$store.state.redeemMenu;
      } else {
        n_menu = this.$store.state.menu;
      }

      if (n_menu == null) {
        return [];
      } else {
        n_menu = n_menu.filter(cat => cat.ID < 0 || cat.menuTypes.includes(this.$store.state.order.orderType));

        if (this.mainMenu.length > 0) {
          n_menu = n_menu.filter(
            cat =>
              this.mainMenuCatSelected == null ||
              (this.mainMenuCatSelected.ID == -1 && cat.ID == -1) ||
              (this.mainMenuCatSelected.ID == 0 && cat.pID == 0 && cat.child_count == 0) ||
              (this.mainMenuCatSelected.ID > 0 &&
                ((cat.pID > 0 && cat.fullID.startsWith(this.mainMenuCatSelected.ID.toString() + "/")) ||
                  (this.mainMenuCatSelected.child_count == 0 && this.mainMenuCatSelected.ID == cat.ID)))
          );
        }

        return n_menu;
      }
    },
  },

  methods: {
    pageBack() {
      if (this.mainMenu.length > 0 && this.mainMenuCatSelected != null) {
        this.mainMenuCatSelected = null;
        this.catID = 0;
      } else this.navBack();
    },

    onScroll() {
      this.resizeLeftMenu();
    },

    onClickMenu() {
      this.$store.state.appBar.showDrawer = true;
    },

    resizeLeftMenu() {
      if (this.$store.getters.categoryPosition == "left") {
        let eleList = document.getElementById("menu-side-list");
        if (eleList) {
          let listHeight = window.innerHeight - this.headerHeight - Math.max(eleList.offsetTop - window.scrollY, 0);
          if (eleList.offsetHeight != listHeight) {
            eleList.style.height = listHeight + "px";
          }
        }
      }
    },

    startMenu() {
      console.log("startMenu");

      if (this.menu.length > 0) {
        let displayCat = this.menu[0];

        if (this.$store.getters.categoryPosition != "top") {
          this.catID = displayCat.ID;
        }
      }
    },

    filteredCatItems(cat) {
      return cat.items.filter(item => item.menuTypes.includes(this.$store.state.order.orderType) && !item.bItem);
    },

    searchItem() {
      if (this.$store.state.orderMenu == 1) this.searchRedeemItem();
      else this.searchMenuItem();
    },

    catClicked(cat) {
      this.catID = cat.ID;

      let that = this;
      if (cat.ID == -1) {
        setTimeout(function() {
          that.scrollToCat(cat.ID);
        }, 1);
      } else if (cat.ID > 0) {
        setTimeout(function() {
          that.scrollToCat(cat.ID);
        }, 1);
      }
    },

    mainMenuCatClicked(mmCat) {
      this.mainMenuCatSelected = mmCat;
      if (mmCat.child_count == 0) this.catClicked(mmCat);
      else {
        if (this.$store.getters.categoryPosition == "left") {
          if (this.menu.length > 0) {
            let cat = this.menu[0];
            this.catID = cat.ID;
          }
        }
      }
    },

    orderTypeSwitched(orderType) {
      this.refreshing = true;
      this.setOrderType(orderType)
        .then(() => {
          console.log("Ordertype switched");
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.refreshing = false;
        });
    },

    scrollToCat(catID) {
      let eleTop = 0;

      let element = document.getElementById(catID);
      if (element) {
        if (this.orderMenuButtonsOnTopBar || this.categoriesOnTopBar) {
          eleTop = element.offsetTop - 48;
        } else {
          if (this.$vuetify.breakpoint.mdAndUp) eleTop = element.offsetTop;
          else eleTop = element.offsetTop;
        }
      }
      let options = { duration: 100, offset: 0, easing: "linear" };
      this.$vuetify.goTo(eleTop, options);
    },

    async itemClicked(item) {
      console.log("item", item);

      if (!this.$store.getters.storeMenuMode) {
        if (item.orderDisabled || item.disabled) return;

        if (this.$store.getters.itemStockEnabled) {
          let response = await this.rest_getItemSoldout([item.ID]);
          if (response.result == "ok" && response.items.length == 1) {
            if (item.soldout) {
              if (!response.items[0].soldout) {
                item.soldout = false;
                this.$root.messageDialog(this.$store.getters.itemDescr(item), "", this.$t("MENU.in_stock"));
              }
            } else {
              if (response.items[0].soldout) {
                item.soldout = true;
                this.$root.messageDialog(this.$store.getters.itemDescr(item), "", this.$t("MENU.out_of_stock"));
              }
            }
          }
        }

        if (item.soldout) return;
      }

      let canNav = true;
      if (item.redeemItem && this.$store.state.member == null) {
        canNav = await this.$root.memberLoginDialog();
      }

      if (canNav) {
        if (this.$store.state.itemFastAdd && item.bItems.length == 0 && item.options.length == 0) {
          if (!this.$store.getters.acceptOrder) {
            this.$root.messageDialog(this.$t("not_acception_order"), "", this.$t("not_acception_order_message"));
            return;
          }
          let orderItem = this.itemToOrderItem(item);
          this.addOrderItem(orderItem);
          if (orderItem.tag != "" && orderItem.cbRefID == 0) {
            let sideItemIDs = this.$store.state.items
              .filter(x => x.combos != null && x.combos.some(x1 => x1.tag == orderItem.tag))
              .map(y => y.ID);

            if (sideItemIDs.length > 0) {
              this.$root
                .confirmDialog(this.$t("confirm_add_side_item"), "", this.$t("confirm_add_side_item_later"))
                .then(resp => {
                  if (resp) {
                    setTimeout(() => {
                      this.navName("MenuItem", { itemIDs: sideItemIDs, sideOrder: true });
                    }, 0);
                  }
                });
            }
          }
        } else this.navOrderView(item);
      }
    },

    navOrderView(item) {
      let params = { item: item };
      if (item.bItems.length > 0 && this.$store.state.serverBuildNo >= 143) {
        this.navName("OrderBundle", params);
      } else {
        this.navName("Order", params);
      }
    },

    checkOutClicked() {
      if (this.$store.state.order.orderItems.length == 0) return;

      this.rest_canAcceptOrder(this.$store.state.order.orderType).then(resp => {
        this.$store.state.storeOrderHours = resp;

        if (this.$store.getters.acceptOrder) {
          if (
            this.$store.state.order.login != null ||
            (this.$store.state.order.orderType == this.$store.state.OT_DINEIN &&
              this.$store.getters.notAskDineInGuestPhone)
          ) {
            this.loginCompleted();
          } else {
            if (
              this.$store.state.memberEnabled &&
              this.$store.state.memberOptional &&
              this.$store.state.member == null
            ) {
              this.showLoginSelector = true;
            } else {
              this.$refs.loginSelector.login(this.$store.state.memberEnabled);
            }
          }
        } else {
          this.$root.messageDialog(this.$t("not_acception_order"), "", this.$t("not_acception_order_message"));

          return;
        }
      });
    },

    loginCancel() {
      this.showLoginSelector = false;
    },

    loginCompleted() {
      this.showLoginSelector = false;
      this.calculateTotal();
      this.navName("Checkout");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/sass/variables.scss";
/* >>> .v-slide-group__wrapper {
  touch-action: auto !important;
} */

.v-chip-group .v-slide-group__content {
  padding: 20px;
}

.v-slide-group__prev {
  min-width: 20px;
}

.v-slide-group__next {
  min-width: 20px;
}

.search-button {
  bottom: 0;
  position: absolute;
  margin: 0 0 16px 16px;
  z-index: 9999;
}

.store-message {
  padding: 10px 10px;
  background-color: var(--v-secondary-lighten1);
  color: var(--v-secondaryText-base);
  text-align: center;

  .col {
    padding: 0px;
  }
}

.not-accept-order {
  text-align: center;
  padding: 10px;
}

.menu-container {
  display: flex;

  .menu-side {
    width: 200px;
    margin-left: -12px;

    border-right-style: solid;
    border-width: 0px 1px 0px 0px;
    border-color: lightgrey;
    .v-list {
      padding: 0px;
      position: sticky;
      top: $header-height;

      //height: 200px; //calc(100vh - #{$header-height});
      overflow-y: auto;
      //overflow-y: scroll;

      .v-list-item {
        line-height: normal;
        padding: 8px 8px;

        .favorite-item {
          //border-left: 4px solid var(--v-info-base);
          //margin-left: -4px;
          border-bottom: 4px solid var(--v-info-base);
        }

        .redeem-item {
          border-bottom: 4px solid var(--v-accent-base);
          //border-left: 4px solid var(--v-accent-base);
          //margin-left: -4px;
        }
      }
    }
  }

  .menu-body {
    width: 100%;
  }
}

.cat-list {
  position: sticky;
  top: $header-height;
  background-color: white;
  z-index: 2;
  margin: 0px -12px;
  padding: 0px 8px;
}

ul.cat-list {
  @extend .cat-list;
  display: flex;
  align-items: center;
  overflow-x: auto;
  overflow-y: hidden;
  margin: 0px -12px;
  padding: 0px 8px;
  height: $cat-list-height;

  li {
    //display: inline;
    list-style-type: none;
    margin: 4px;
    white-space: nowrap;
  }
}

.cat-list-desktop::-webkit-scrollbar {
  height: 8px;
}

.cat-list-mobile::-webkit-scrollbar {
  height: 0px;
}

/* ::-webkit-scrollbar {
  //-webkit-appearance: none;
  height: 8px;
  //width: 7px;
}
*/

::-webkit-scrollbar-thumb {
  //border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.1);
  //box-shadow: 0 0 1px rgba(214, 157, 157, 0.1);
}

.menu-cat-header {
  position: sticky;
  //top: calc(#{$header-height} + #{$cat-list-height});
  left: 0;
  right: 0;
  z-index: 1;
}

.menu-cat-header-top {
  @extend .menu-cat-header;
  top: calc(#{$header-height} + #{$cat-list-height});
}

@media screen and (min-width: 960px) {
  .gmap {
    width: 100%;
    height: calc(100vh - 500px);
  }
}

.menu-cat-header-side {
  @extend .menu-cat-header;
  top: $header-height;
  margin-left: 0px;
}

.menu-cat-header-hidden {
  height: 0px;
}

/* .cat-list-fav {
  color: var(--v-info-base);
  font-size: 1.2em;
}

.cat-list-redeem {
  color: var(--v-accent-base);
  font-size: 1.2em;
  padding-bottom: 3px;
} */

.cat-normal {
  background-color: var(--v-secondary-base);
  color: var(--v-secondaryText-base);
}

.cat-favorite {
  background-color: var(--v-info-base);
  color: var(--v-infoText-base);
}

.cat-redeem {
  background-color: var(--v-accent-base);
  color: var(--v-accentText-base);
}

.menu-cat-detail {
  background-color: var(--v-secondary-lighten1);
  color: var(--v-secondaryText-base);
  padding: 5px 10px;
  font-size: 0.9em;
  span {
    white-space: pre-line;
  }
}
.menu-cat-detail-top {
  @extend .menu-cat-detail;
}
.menu-cat-detail-side {
  @extend .menu-cat-detail;
  margin-left: 0px;
}
</style>
